import axios from 'axios'
import resolveRequest from '../../utils/resolveRequest.js'
import { apiEndpoints, SERVER_PATH } from '../endpoints.js'

export default async () => {
  const endpoint = `${apiEndpoints.products}`
  const URL = SERVER_PATH + endpoint
  return resolveRequest(axios.get(URL, { withCredentials: true }))
}
